import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from '../../../utils/Utils';
import settings from "src/devices/all/settings";

class ConfirmTask extends AbstractRequestTask {
    constructor(url, params = {}, method = 'GET', paramsPOST = {}, showErrorModal = true) {
        super();

        this.url = url;
        this.params = params;
        this.method = method;
        this.paramsPOST = paramsPOST;
        this.showErrorModal = showErrorModal;
    }

    getMethod() {

        return this.method;
    }

    getHeaders() {
      const params = super.getParams();
        if (this.method === 'GET') {
          if (this.url.includes('/v1/')) {
            return {
              'Content-Type': 'application/json',
              'user-token': params.user_token
            };
          }
            return {};
        } else {
            return {
                'Content-Type': 'application/x-www-form-urlencoded'
            };
        }
    }

  //Extra la version de la url
  getVersionFromUrl(version) {

    const arrUrl = this.url.split('/');
    const index = arrUrl.findIndex((element) => element === 'api_version');

    if (arrUrl[index + 1]) {
      return arrUrl[index + 1];
    }

    return version;

  }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");

        const queryString = this.method === 'POST' ? (`?${this.getQueryStringParams()}`) : '';

        if(settings.fake_url_mockoon) {
          return `${settings.fake_url_mockoon}${this.url}${queryString}`;
        }
        else {
          return `${http}${url}/${this.url}${queryString}`;
        }
    }

    getQueryStringParams()
    {

      const baseParams = super.getParams();
      delete baseParams.user_token;

      //Fix https://dlatvarg.atlassian.net/browse/STV-6170
      if (this.method === 'POST') {
        if (this.url.includes('/v1/')) {
          delete baseParams.HKS;
          delete baseParams.api_version;
        }

        //Este metodo no debe llevar api_version, a menos que lo traiga desde el buyLink de payway/workflowstart
        delete baseParams.api_version;
      }

      const parms = Object.assign({}, baseParams, this.params);
      const result = Utils.buildQueryParams(parms);

      return result;
    }

    getParams() {

      const params = super.getParams();
      const { user_token = ''} = params;

      if (this.method === 'GET') {
        if (this.url.includes('/v1/')) {
          delete params.HKS;
          delete params.api_version;
          delete params.user_token;
        }
            return Object.assign({}, params, this.params);
        }
        else
        {
            return Object.assign({}, this.paramsPOST, { token: user_token })
        }
    }

    isValid(data) {

        if (data.errors || !data.response || data.response === 'error') {
            return false;
        }
        return true;
    }

    success(data, b) {
        this.resolve(data);
    }

    parseErrors(err) {

      if (err !== undefined){
        return super.parseErrors(err)
      }
    }

    getShowErrorModal(){
		return this.showErrorModal;
  }

  showModalRetry() {
    return false;
  }

  getRetriesNumber() {
    return 0;
  }
}

export default ConfirmTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/payway/ConfirmTask.js